/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleMetadata } from './moduleMetadata';

export type ModuleLecturerResponseMetadata = ModuleMetadata | null;
